import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

// Flags a brief window on every pathname change so a loading indicator can
// show even when the destination route's chunk is already cached (Suspense
// only fires for genuinely pending lazy imports).
export default function useRouteTransition(duration = 300) {
  const location = useLocation();
  const [transitioning, setTransitioning] = useState(false);
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    if (prevPathRef.current === location.pathname) return;
    prevPathRef.current = location.pathname;
    setTransitioning(true);
    const timer = setTimeout(() => setTransitioning(false), duration);
    return () => clearTimeout(timer);
  }, [location.pathname, duration]);

  return transitioning;
}
